import React, {Component} from 'react'
import {Button, Table} from 'reactstrap';
import Location from './Location';

export default class LocationTable extends Component {

    render() {
        const locations = this.props.locations;
        return (
            <Table>
                <caption>
                    <Button color="primary">Standort hinzufügen</Button>
                </caption>
                <thead>
                <tr>
                    <th>
                        Name
                    </th>
                    <th>
                        PLZ
                    </th>
                    <th>
                        Straße
                    </th>
                    <th>

                    </th>
                </tr>
                </thead>
                <tbody>
                {
                    locations.map(
                        (location, index) => <Location key={`location_${index}`} location={location}/>
                    )
                }
                </tbody>
            </Table>
        )
    }

}